<template lang="pug">
  #sale-debit-note-create
    // CREATE
    r-form(
      ref='form'
      submit-text='crear'
      title='Crear nota de debito'
      v-bind='formProps'
      v-model='formData'
      @reset='reset'
      @submit='onSubmitForm'
      )
      template( slot='dte-number-append' v-if='canShowSearch' )
        v-btn(
          color='primary'
          dark
          depressed
          style='margin-top:-8px'
          @click='onClickSearch'
          )
            span buscar &nbsp;
            v-icon search

    // CREDIT NOTE
    r-table-picker(
      :no-pagination='false'
      param-search='number'
      ref='slSaleCreditNotePicker'
      selected-one
      title='seleccionar nota de credito de venta'
      v-bind='slSaleCreditNotePickerProps'
      v-model='pickers.slSaleCreditNote'
      @submit='submitPicker'
      )

    // INVOICE
    r-table-picker(
      :no-pagination='false'
      param-search='number'
      ref='picker'
      selected-one
      v-bind='slSaleInvoicePickerProps'
      v-model='pickers.slSaleInvoice'
      @submit='submitPicker'
      )
</template>

<script>
  //
  import { mapActions, mapState } from 'vuex'
  import {
      RForm,
      RTablePicker,
  } from '../../../components/reusable_components/next'
  //
  import SaleInvoiceModel from '../../../models/Sale/SlSaleInvoice'
  import SaleDebitNoteModel from '../../../models/Sale/SlSaleDebitNote'
  //
  import SaleInvoiceHeaders from '../../../views/Sale/SlSaleInvoice/SlSaleInvoiceHeaders'
  import SaleDebitNoteFields from '../../../views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
  // SlSaleCreditNote Modules
  import SlSaleCreditNoteFilters from '@/views/Sale/SlSaleCreditNote/SlSaleCreditNoteFilters'
  import SlSaleCreditNoteHeaders from '@/views/Sale/SlSaleCreditNote/SlSaleCreditNoteHeaders'
  import SlSaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'
  import SlSaleCreditNoteService from '@/services/api2/Sale/SlSaleCreditNote'
  // SlDebitNote Modules
  import SlSaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
  import SlSaleDebitNoteService from '@/services/api2/Sale/SlSaleDebitNote'
  // SlSaleInvoice Modules
  import SlSaleInvoiceFilters from '@/views/Sale/SlSaleInvoice/SlSaleInvoiceFilters'
  import SlSaleInvoiceService from '@/services/api2/Sale/SlSaleInvoice'
  //
  import TranslatorService from '../../../services/translator'
  //
  export default {
    name: 'sl-sale-debit-note-create',
    components: {
      RForm,
      RTablePicker,
    },
    computed: {
      /**
       *
       */
      ...mapState('SnackbarModalModule', ['responseConfirm']),

      /**
       * Determines if the view can show the search button
       * @returns {Object} picker props
       */
      canShowSearch() {
        return this.slSaleDebitNoteReferenceType !== 1
      },

      /**
       *
       */
      formProps() {
        return {
          //fields: SlSaleDebitNoteFields.toCreate()
          fields: SaleDebitNoteFields.variant(
              this.formData.type_reference_document === 2
                  // ? 'create-invoice'
                  ? 'create-invoice'
                  : 'create-invoice'
          ),
        }
      },

      /**
       * SlSaleCreditNotePicker props
       * @returns {Object} picker props
       */
      slSaleCreditNotePickerProps() {
        return {
          filters: SlSaleCreditNoteFilters,
          headers: SlSaleCreditNoteHeaders,
          service: SlSaleCreditNoteService.toList(),
        }
      },

      /**
       * SlDebitNote Reference Type
       * @return {String} reference id
       */
      slSaleDebitNoteReferenceType() {
        return this.formData.type_reference_document
      },

      /**
       * SlSaleInovoicePicker props
       * @returns {Object} picker props
       */
      slSaleInvoicePickerProps() {
        return {
          filters: SlSaleInvoiceFilters,
          headers: SaleInvoiceHeaders,
          service: SlSaleInvoiceService.toList(),
        }
      }
    },
    data() {
      return {
        formData: new SaleDebitNoteModel({
          dte_number: '',
          reason: '',
          sl_sale_invoice: {},
          total_amount: 0,
          type_reference_document: 1,
          stock_return: false,
        }),
        models: {
          slSaleDebitNote: new SaleDebitNoteModel({
            dte_number: '',
            reason: '',
            sl_sale_invoice: {},
            total_amount: 0,
            type_reference_document: 0,
            stock_return: false,
          }),
        },
        pickers: {
          slSaleInvoice: false,
          slSaleCreditNote: false,
        },
      }
    },
    methods: {

      /**
       *
       */
      redirect() {
        this.$router.push({ name: 'sale-debit-note-list' })
      },

      /**
       * Resets the object.
       */
      reset(model) {
        model.type_reference_document = ''
        model.dte_number = ''
        model.reason = ''
        model.sl_sale_invoice = null
        model.total_amount = ''
      },

      /**
       * Return the submit of picker
       * @param   {Object}  event - The event payload
       */
      submitPicker(event) {

        // required data
        const slSaleDocumentSelected = event.selected.slice().pop()

        // set required data
        this.formData.sl_tax_document_id = slSaleDocumentSelected.id
        this.formData.dte_number = slSaleDocumentSelected.getProperty('number', '')
        this.formData.sl_sale_invoice = slSaleDocumentSelected

        // only if has selected a sl sale credit note
        if (this.slSaleDebitNoteReferenceType === 3) {
          this.formData.total_amount = slSaleDocumentSelected.total
        } 
      },

      /**
       * Show the required picker according to the current
       * SlSaleDebitNoteReference Type.
       */
      onClickSearch() {
        switch (this.slSaleDebitNoteReferenceType) {

          // show the sale invoice picker
          case 2: this.pickers.slSaleInvoice = true;
            break;

          // show the sale credit note picker
          case 3: this.pickers.slSaleCreditNote = true;
            break;

          // default
          default: ;
            break;
        }
      },

      /**
       * 
       */
      onSubmitForm() {
        switch (this.slSaleDebitNoteReferenceType) {

          // wait the create services promise
          case 2: this.toWait(true).then(this.toCreate).then(this.toWait);
            break;

          // wait the cancel services promise
          case 3: this.toWait(true).then(this.toCancel).then(this.toWait);
            break;

          // default  
          default: ;
            break;
        }
      },

      /**
       * 
       */
      toCancel(slSaleDebitNote) {
        
        // required data
        const slSaleCreditNote = new SlSaleCreditNoteModel({
          id: slSaleDebitNote.sl_tax_document_id,
          reason: slSaleDebitNote.reason,
        })

        //
        return SlSaleCreditNoteService
          .cancel(slSaleCreditNote)
          .then(this.toCancelSuccess)
          .then(this.redirect)
          .catch(this.toError)
      },

      /**
       * 
       */
      toCancelSuccess() {
        this.showSuccessSnackbar('Nota de debito agregada exitosamente.')
      },

      /**
       * The create form promise
       * @param   {Object}  slSaleDebitNote - The sl sale debit note model
       * @return  {Promise} create promise
       */
      toCreate(slSaleDebitNote) {
        return SlSaleDebitNoteService
          .createWithPdf(slSaleDebitNote)
          .then(this.toCreateSuccess)
          .then(this.redirect)
          .catch(this.toError)
      },

      /**
       * 
       */
      toCreateSuccess() {
        this.showSuccessSnackbar('Nota de debito agregada exitosamente.')
      },

      /**
       * 
       */
      toError(error) {
        this.showErrorSnackbar(TranslatorService(SaleDebitNoteModel, error.response.data))
      },

      /**
       * 
       */
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    mounted() {
      this.setTitle('Crear nota de debito')
    },
    watch: {
      
      /**
       * Determine and set the readonly property in the
       * total and amount field
       * 
       * @param {Number} id - sl sale debit note reference document id
       */
      slSaleDebitNoteReferenceType(id) { console.log('watch')
        if (id !== 3) this.formProps.fields[5].props.readonly = false
        this.formProps.fields[3].props.readonly = true
        
        this.formProps.fields[6].props.disabled = id !== 3
        this.formData.stock_return = false
      }
    },
  }
</script>
